import { PathOptions } from "leaflet";

export const area_quilombola = (feature: any): PathOptions => {
  return {
    color: "#8B4513",
    weight: 2,
    opacity: 1,
    fillColor: "#A0522D",
    fillOpacity: 0.5,
  };
};
